const doc = [({"municipality":"Commune", "canton":"Canton", "burdenLong":"Charge", "burdenShort":"Charge", "sortOrder":"Inverser le tri", "showMore":"Afficher 20 communes de plus"})];
module.exports = doc.length <= 1 ? doc[0] : doc;